import Controller from '@ember/controller';
import { action } from '@ember/object';

export default class AuthenticatedPlaylistsShowController extends Controller {
  @action
  controllerRefresh(playlist) {
    console.log('controllerRefresh');
    this.send('routeRefresh', playlist);
  }
}
